import mod from "-!../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./readyExam.vue?vue&type=script&lang=js&"; export default mod; export * from "-!../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./readyExam.vue?vue&type=script&lang=js&"


//////////////////
// WEBPACK FOOTER
// ./src/views/exam/readyExam.vue?vue&type=script&lang=js&
// module id = siR+
// module chunks = 0